<template>
  <div class="input-wrap" :class="getValidationClass()">
    <slot />
    <div class="error-msg" v-if="field.required === false">
      You left the field blank.
    </div>
    <div class="error-msg" v-else-if="field.minValue === false">
      must be more or equal to {{ min }}.
    </div>
    <div class="error-msg" v-else-if="field.maxValue === false">
      must be less or equal to {{ max }}.
    </div>
    <div class="error-msg" v-else-if="field.minDate === false">
      must be more than
      {{ minDateText }}.
    </div>
    <div class="error-msg" v-else-if="field.maxDate === false">
      must be less or equal to
      {{ field.$params.maxDate.max.toISOString().substring(0, 10) }}.
    </div>
    <div
      class="error-msg"
      v-else-if="
        field.minLength === false &&
          field.$params.maxLength &&
          field.$params.minLength.min === field.$params.maxLength.max
      "
    >
      must be {{ field.$params.minLength.min }} symbols.
    </div>
    <div class="error-msg" v-if="field.maxLength === false">
      must be less or equal to {{ field.$params.maxLength.max }} symbols.
    </div>
    <div class="error-msg" v-else-if="field.minLength === false">
      must be more or equal to {{ field.$params.minLength.min }} items.
    </div>
    <div class="error-msg" v-else-if="field.shouldBeYes === false">
      must be Yes (Employer Match requirements less that Employee Contributions
      requirements)
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { RESET_ALTERNATIVE_DESIGNS_STATE } from "@/store/actions.type";
export default {
  name: "RoeErrorMessage",
  props: {
    field: {
      type: Object,
      default: () => {
        return {};
      }
    },
    minValue: {
      required: false
    },
    minDate: {
      required: false
    }
  },
  watch: {
    "field.$model": function() {
      this.$store.dispatch(RESET_ALTERNATIVE_DESIGNS_STATE);
      this.field.$touch();
    }
  },
  computed: {
    ...mapGetters(["showAllErrors"]),
    anyErrorMessage() {
      return (
        this.field.required === false ||
        this.field.maxValue === false ||
        this.field.minLength === false ||
        this.field.minValue === false ||
        this.field.minDate === false ||
        this.field.maxDate === false ||
        this.field.maxLength === false ||
        this.field.shouldBeYes === false
      );
    },
    min() {
      let value = +this.minValue || this.field.$params.minValue.min;

      return this.toString(value);
    },
    max() {
      let value = this.field.$params.maxValue.max;
      return this.toString(value);
    },
    minDateText() {
      let date = this.minDate || this.field.$params.minDate.min;
      return date.toISOString().substring(0, 10);
    }
  },
  methods: {
    getValidationClass() {
      if (this.field && this.anyErrorMessage) {
        return {
          error: this.showAllErrors ? this.field.$invalid : this.field.$error
        };
      }
    },
    toJsPercent(value) {
      return `${Number((value * 100).toFixed(2))}%`;
    },
    toString(value) {
      if (this.field.percent) return this.toJsPercent(value);
      if (this.field.currency)
        return `$${(parseFloat(value).toFixed(2) * 100) / 100}`;

      return value;
    }
  }
};
</script>
